<template>
  <v-container>
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="10">
        <p>Never miss a recipe!</p>
        <v-form
          ref="form"
          v-model="valid"
          @submit="validate"
          @submit.prevent
          novalidate
        >
          <v-row>
            <v-col cols="12" md="5">
              <v-text-field
                dense
                label="Your name"
                v-model="form.name"
                :rules="rules.name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                dense
                label="Your email"
                type="email"
                v-model="form.email"
                :rules="rules.email"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" class="text-center">
              <v-btn
                color="primary"
                small
                type="submit"
                :disabled="!valid || submitting"
              >Submit</v-btn>
            </v-col>
          </v-row>
        </v-form>

      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import {
  VBtn,
  VCol,
  VContainer,
  VForm,
  VRow,
  VTextField,
} from 'vuetify/lib'

import {Validators} from '@/utils/validators'
import MailerService from '@/services/MailerService'

export default {
  components: {
    VBtn,
    VCol,
    VContainer,
    VForm,
    VRow,
    VTextField,
  },
  data: () => ({
    form: {
      email: '',
      name: '',
    },
    rules: {
      email: [
        value => Validators.required(value) || 'Email is required.',
        value => Validators.email(value),
      ],
      name: [
        value => Validators.required(value) || 'Name is required.',
      ]
    },
    submitting: false,
    valid: false,
  }),
  methods: {
    reset() {
      this.$ref.form.reset()
      this.submitting = false
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.submitting = true
        MailerService
          .subscribe(this.form.email, this.form.name, ['recipes'])
          .then(() => {
            this.submitting = false
          });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  font-size: 15px;
  font-weight: bold;
  margin: 0 0 12px 0 !important;
  padding: 0;
  text-transform: uppercase;
}
</style>
